import React, { useContext, useEffect, useState } from 'react';
import ArtworldContext from './../../context/ArtworldContext';
import Select from 'react-select';
import { findSearchOption } from './../../helpers';

const inputKey = 'sources__categories__in'

let optionsSelected = null

var _ = require('lodash');

const SourcesCategories = () => {

    const context = useContext(ArtworldContext);

    const [options, setOptions] = useState('')

    const onChange = selectedOptions => {

        const selected = selectedOptions ? selectedOptions.map(selectedOption => {
            return selectedOption.value
        }) : context.advancedSearch[inputKey]

        context.updateAdvancedSearch('sources', 'categories__in', selected);

        optionsSelected = selected
    };

    /**
     * Create options list when filters return from API
     */
    useEffect(() => {

        if (context.advancedSearchFilters && context.advancedSearchFilters.sources && context.advancedSearchFilters.sources.categories) {

            const options = context.advancedSearchFilters.sources.categories.map(category => {
                return {
                    value: category.id,
                    label: category.title
                }
            })

            setOptions(options)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [context.advancedSearchFilters])

    if (window.location.search) {
        optionsSelected = findSearchOption(inputKey)
        // make sure it's a array otherwise the id will be split by number
        optionsSelected = typeof optionsSelected === 'string' ? [optionsSelected] : optionsSelected

        optionsSelected = _.map(optionsSelected, function (k) {
            return parseInt(k)
        })
    }

    return (
        <div className="columns is-multiline is-variable">

            <div className="column is-full">

                Documentary sources:

                <Select
                    value={options && optionsSelected ? options.filter(option => optionsSelected.includes(option.value)) : ''}
                    onChange={onChange}
                    options={options}
                    isMulti
                />

            </div>

        </div>
    );
};

export default SourcesCategories;
